function apiParamCommon(ApiData, ParamCommon = {}) {
  return {
    ApiData,
    ParamCommon,
  };
}
export { apiParamCommon };
